import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './index.module.scss';
import OfferTerms from './components/OfferTerms';
import { BottomSheet } from 'react-spring-bottom-sheet';

import backArrow from '../../assets/global/arrow-left.svg';
import twidLogo from '../../assets/global/twid.svg';
import rightPrimary from '../../assets/global/rightPrimary.svg';
import { isObjectEmpty, viewportToPixels } from '../../utils/common.utils';
import { useOfferDetails } from '../../api/api.calls';
import ContentLoader from 'react-content-loader';
import { ctLogV2 } from '../../utils/cleverTapLogger.utils';
import { useIdHash, useNavigateRoute } from '../../hooks/custom.hooks';

function OffersDetailPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramsObject = Object.fromEntries(searchParams.entries());
  const { vcdi = '' } = paramsObject;
  const navigateRoute = useNavigateRoute();
  const offerQuery = useOfferDetails();
  const { data: offerDetails, isLoading, isFetching } = offerQuery;
  const { offer, brand_redirect_url, how_to_redeem, tnc } =
    offerDetails?.data || {};

  /*const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate(); // Get the day (30)
    const month = date
      .toLocaleString('default', { month: 'short' })
      .toUpperCase(); // Get the month (SEP)
    const year = date.getFullYear(); // Get the year (2024)
    return `${day} ${month} ${year}`;
  };*/

  const parseColorCode = (code = '') => {
    return code.includes('#') || code.startsWith('rgb') ? code : `#${code}`;
  };

  const {
    voucher_code = '',
    voucher_image_url,
    // voucher_expiry,
    voucher_title,
    voucher_subtitle,
    voucher_type_url,
    voucher_type_text,
    voucher_type_color,
    brand_logo,
    brand_name,
    expiry_logo,
    expiry_text,
    expiry_text_color,
    applicable_brand_logos,
    is_single_merchant,
    reward_details_id,
    voucher_campaign_details_id,
    type,
    // is_claimable,
    // offer_filter_type = '',
  } = offer || {};

  const merchantNames = applicable_brand_logos?.brand_names
    ?.slice(0, 25)
    .join(', ');

  let showClaim = ['recommended', 'exclusive'].includes(
    voucher_type_text?.toLowerCase(),
  );
  showClaim = false; // @TODO - to be implemented later

  // State to track the active div's index
  const [activeIndex, setActiveIndex] = useState('offer');

  const [open, setOpen] = useState(false);

  const { custId: cid, isApp } = useIdHash();

  // Clevertap Details
  const fullUrl = window.location.href;
  const platform = isApp ? 'app' : 'web';
  const activeSource = isApp
    ? 'applp_recommendedoffers_click'
    : 'weblp_v1_topoffers_click';
  const voucher_id = vcdi;
  const offerTypeText = localStorage.getItem('offerTypeText');
  useEffect(() => {
    ctLogV2({
      eventName: 'Web_Offerdetailspage_viewed',
      eventCategory: 'Offer Details Page',
      eventDescription: 'Offer Details Page - Offer Viewed',
      customerId: cid,
      extraData: {
        identity: cid || '',
        url: fullUrl,
        platform: platform || '',
        source: activeSource || '',
        offerID:
          voucher_id ||
          reward_details_id ||
          voucher_campaign_details_id ||
          type ||
          '',
        coupon_code: voucher_code,
        offer_title: voucher_title,
        offer_subtitle: voucher_subtitle,
        offer_type: offerTypeText || voucher_type_text || '',
        Merchants: merchantNames,
      },
    });
    window.scrollTo(0, 0);
  }, [
    fullUrl,
    platform,
    activeSource,
    voucher_id,
    voucher_code,
    voucher_title,
    voucher_subtitle,
    voucher_type_text,
    merchantNames,
    cid,
    reward_details_id,
    voucher_campaign_details_id,
    type,
    offerTypeText,
  ]);

  const fallbackExpiryLogo =
    'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png';
  const fallbackBrandLogo =
    'https://static.twidpay.com/me/co/mobile_app_images/icons/all-brand-logos.svg';
  const fallbackBannerLogo =
    'https://static.twidpay.com/me/co/mobile_app_images/icons/offer-banner-logo.svg';
  const errorImage =
    'https://static.twidpay.com/me/co/mobile_app_images/icons/infoError.svg';

  const [sectionWidth, setSectionWidth] = useState(
    document.getElementById('root')?.clientWidth || 440,
  );

  useLayoutEffect(() => {
    if (!isLoading) {
      setSectionWidth(
        document.getElementById('offerDetailsPage')?.clientWidth ||
          document.getElementById('root')?.clientWidth ||
          440,
      );
    }
  }, [isLoading, setSectionWidth]);

  const handleClick = (showtype) => {
    if (showtype === 'howto') {
      document.getElementById('scrollContent').scrollTo({
        left: sectionWidth,
        behavior: 'smooth',
      });
    } else if (showtype === 'offer') {
      document.getElementById('scrollContent').scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
    setActiveIndex(showtype); // Set the clicked index as active
  };

  if (isLoading || isFetching) {
    return (
      <div className={styles.appLayout}>
        <ContentLoader
          speed={2}
          backgroundColor="#1C2B5A"
          foregroundColor="#162143"
          width={`calc(100% - 32px)`}
          height={'100dvh'}
          style={{
            padding: 0,
          }}
        >
          <rect x="16" y="24" rx="2" ry="2" width="30" height="30" />
          <rect x="70" y="16" rx="2" ry="2" width="40" height="40" />
          <rect x="120" y="24" rx="2" ry="2" width="180" height="20" />
          <rect x="16" y="100" rx="2" ry="2" width="20%" height="30" />
          <rect x="30%" y="100" rx="2" ry="2" width="30%" height="30" />
          <rect x="70%" y="100" rx="8" ry="8" width="30%" height="30" />
          <rect x="16" y="150" rx="8" ry="8" width="96%" height="219" />
          <rect x="16" y="390" rx="8" ry="8" width="15%" height="30" />
          <rect x="20%" y="390" rx="8" ry="8" width="20%" height="30" />
          <rect x="16" y="430" rx="8" ry="8" width="60%" height="30" />
          <rect x="16" y="470" rx="8" ry="8" width="80%" height="20" />
        </ContentLoader>
      </div>
    );
  }

  const isExpired = isObjectEmpty(offerDetails?.data);

  return (
    <>
      <div className={styles.appLayout} id="offerDetailsPage">
        <div className={styles.appHeader} id="appHeader">
          <div
            onClick={() => {
              navigateRoute({
                goBack: true,
                state: {
                  navigated: true,
                },
              });
            }}
          >
            <img src={backArrow} alt="<" className={styles.back} />
          </div>

          <img
            src={isExpired ? twidLogo : brand_logo || fallbackBrandLogo}
            alt="logo"
            className={styles.brandLogo}
            style={{
              width: isExpired ? '63px' : '40px',
              height: isExpired ? '32px' : 'auto',
            }}
            id="brandImg"
            onError={() => {
              document.getElementById('brandImg').src = fallbackBrandLogo;
            }}
          />

          <div className={styles.brandName}>
            <div>{brand_name}</div>
            <div className={styles.voucherCode}>{voucher_code}</div>
          </div>
        </div>

        {isExpired ? (
          <div className={styles.emptyOffer}>
            <img src={errorImage} alt="error" />
            <h2>Offer No Longer Available</h2>
            <h4>Discover what&apos;s new in our latest deals</h4>
            <button
              onClick={() => {
                navigateRoute({
                  nextPage: '/',
                });
              }}
            >
              EXPLORE MORE OFFERS
            </button>
          </div>
        ) : (
          <div className={styles.contentBody}>
            <div className={styles.appBody}>
              <div
                className={`${styles.offerSection} ${
                  activeIndex === 'offer' ? styles.offerSectionActive : ''
                }`}
                onClick={() => handleClick('offer')}
              >
                <span>Offer</span>
              </div>
              {how_to_redeem?.length ? (
                <div
                  className={`${styles.offerSection} ${
                    activeIndex === 'howto' ? styles.offerSectionActive : ''
                  }`}
                  onClick={() => {
                    ctLogV2({
                      eventName: 'Web_offerhowtoredeem_clicked',
                      eventCategory: 'Offer Details Page',
                      eventDescription:
                        'Offer Details Page - How to Redeem Clicked',
                      customerId: cid,
                      extraData: {
                        offerID:
                          voucher_id ||
                          reward_details_id ||
                          voucher_campaign_details_id ||
                          type ||
                          '',
                        coupon_code: voucher_code || '',
                        offer_type: offerTypeText || voucher_type_text || '',
                        offer_subtitle: voucher_subtitle || '',
                      },
                    });
                    handleClick('howto');
                  }}
                >
                  <span>How to Redeem?</span>
                </div>
              ) : null}
              {/* <div
            className={`${styles.offerSection} ${
              activeIndex === 'simoff' ? styles.offerSectionActive : ''
            }`}
            onClick={() => handleClick('simoff')}
          >
            <span>Similar Offers</span>
          </div> */}
            </div>

            <div
              className={styles.scrollContent}
              id="scrollContent"
              onScroll={() => {
                const left =
                  document.getElementById('scrollContent').scrollLeft;
                if (left > sectionWidth / 2) {
                  setActiveIndex('howto');
                } else {
                  setActiveIndex('offer');
                }
              }}
            >
              <div
                className={styles.offerImgContent}
                style={{
                  minWidth: sectionWidth,
                }}
              >
                <div className={`${styles.offerContent}`}>
                  <div
                    className={styles.bannerWrapper}
                    style={{
                      height: 219,
                      width: '100%',
                    }}
                  >
                    <img
                      className={styles.bannerLogo}
                      src={voucher_image_url || fallbackBannerLogo}
                      alt="bannerLogo"
                      id="bannerLogo"
                      onError={() => {
                        document.getElementById('bannerLogo').src =
                          fallbackBannerLogo;
                      }}
                    />
                  </div>

                  <div className={styles.offerDetails}>
                    <div className={styles.offerCardTag}>
                      {voucher_type_url ? (
                        <img
                          src={voucher_type_url}
                          alt="offer_type"
                          id="offer_type"
                          onError={() => {
                            document.getElementById('offer_type').src =
                              fallbackExpiryLogo;
                          }}
                        />
                      ) : null}
                      <span
                        className={styles.offerTypeText}
                        style={{ color: parseColorCode(voucher_type_color) }}
                      >
                        {voucher_type_text}
                      </span>
                      {expiry_text ? (
                        <>
                          <span className={styles.separator}></span>
                          <img
                            className={styles.expiryLogo}
                            src={expiry_logo ?? fallbackExpiryLogo}
                            alt=""
                          />
                          <span style={{ color: expiry_text_color }}>
                            {expiry_text}
                          </span>
                          {/* {expiry_text ? (
                            <span style={{ color: expiry_text_color }}>
                              {expiry_text}
                            </span>
                          ) : (
                            <>
                              <span style={{ color: expiry_text_color }}>
                                Expires {formatDate(voucher_expiry)}
                              </span>
                            </>
                          )} */}
                        </>
                      ) : null}
                    </div>
                    <div className={styles.offerInfo}>
                      <p>{voucher_title}</p>
                      <p>{voucher_subtitle}</p>
                      {applicable_brand_logos?.logos?.length > 0 ? (
                        <>
                          <p>
                            Offer available on following
                            {applicable_brand_logos?.logos?.length === 1
                              ? ' Brand'
                              : ' Brands'}
                          </p>
                          <div
                            className={styles.offerMore}
                            onClick={() => {
                              // here have to pass brand_ids list
                              navigateRoute({
                                nextPage: `/brands/?selected=${applicable_brand_logos?.brand_ids.join(',')}`,
                              });
                            }}
                          >
                            {applicable_brand_logos.logos
                              .slice(0, 3)
                              .map((logoUrl, index) => (
                                <img
                                  key={index}
                                  src={logoUrl}
                                  alt={`Logo ${index + 1}`}
                                  id={`Logo_${index + 1}`}
                                  onError={() => {
                                    document.getElementById(
                                      `Logo_${index + 1}`,
                                    ).src = fallbackBrandLogo;
                                  }}
                                />
                              ))}
                            {applicable_brand_logos.extra_count ? (
                              <p>{applicable_brand_logos.extra_count}</p>
                            ) : applicable_brand_logos?.logos?.length > 3 ? (
                              <p>
                                +{applicable_brand_logos?.logos?.length - 3}{' '}
                                more
                              </p>
                            ) : null}
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {how_to_redeem?.length ? (
                <div
                  className={styles.howToRedeemContent}
                  style={{
                    minWidth: sectionWidth,
                  }}
                >
                  <div className={styles.howToContent}>
                    {how_to_redeem?.map((item, index) => (
                      <div
                        className={`${styles.redeemSteps} ${
                          index === how_to_redeem.length - 1 &&
                          styles.redeemStepsLast
                        }`}
                        key={index + 1}
                      >
                        <div className={styles.info}>
                          <img
                            src={item.image}
                            alt={`Step ${index + 1}`}
                            id={`howto_img_${index + 1}`}
                            onError={() => {
                              document.getElementById(
                                `howto_img_${index + 1}`,
                              ).src = fallbackBrandLogo;
                            }}
                          />
                          <p
                            className={
                              item?.data.length > 100 ? styles.handleHtrTxt : ''
                            }
                            title={item.data}
                          >
                            {item.data}
                          </p>
                        </div>
                        <div className={styles.countWrapper}>
                          <div
                            className={`${
                              index === how_to_redeem.length - 1
                                ? styles.lastRedeemStep
                                : styles.redeemStepsCount
                            }`}
                          >
                            {index + 1}
                          </div>
                          <div
                            className={styles.dummyDIV}
                            style={{
                              display:
                                index === how_to_redeem.length - 1
                                  ? 'none'
                                  : 'inline-flex',
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>

      {isExpired ? null : showClaim || brand_redirect_url || tnc ? (
        <div
          className={
            open ? styles.offerBottomContentOpen : styles.offerBottomContent
          }
        >
          <div className={styles.actions}>
            {tnc ? (
              <div
                className={`${styles.termsAndCond} ${open && styles.openTnC} ${
                  !brand_redirect_url && styles.openCenterTnC
                }`}
                onClick={() => {
                  if (!open) {
                    ctLogV2({
                      eventName: 'Web_offertnc_clicked',
                      eventCategory: 'Offer Details Page',
                      eventDescription: 'Offer Details Page - TnC Clicked',
                      customerId: cid,
                      extraData: {
                        offerID:
                          voucher_id ||
                          reward_details_id ||
                          voucher_campaign_details_id ||
                          type ||
                          '',
                        coupon_code: voucher_code || '',
                        offer_type: offerTypeText || voucher_type_text || '',
                        offer_subtitle: voucher_subtitle || '',
                      },
                    });
                  }
                  setOpen(!open);
                }}
                style={{
                  color: open ? '#FFA586' : '#FAFAFAA3',
                  justifyContent: brand_redirect_url ? '' : 'center',
                }}
              >
                T&C
              </div>
            ) : null}
            {showClaim ? (
              <div className={`${styles.visitBrand} ${styles.visitBrandClaim}`}>
                <a href="javscript:void(0);">
                  Claim
                  <img src={rightPrimary} alt=">" className={styles.rightPri} />
                </a>
              </div>
            ) : brand_redirect_url ? (
              <div
                className={`${styles.visitBrand} ${
                  tnc && styles.visitBrandTnc
                }`}
              >
                <a
                  href={brand_redirect_url}
                  onClick={() => {
                    ctLogV2({
                      eventName: 'Web_offerCTA_clicked',
                      eventCategory: 'Offer Details Page',
                      eventDescription:
                        'Offer Details Page - CTA button clicked',
                      extraData: {
                        offerID:
                          voucher_id ||
                          reward_details_id ||
                          voucher_campaign_details_id ||
                          type ||
                          '',
                        coupon_code: voucher_code || '',
                        offer_title: voucher_title || '',
                        offer_subtitle: voucher_subtitle || '',
                        offer_type: offerTypeText || voucher_type_text || '',
                        merchants: merchantNames || '',
                        cta_text: is_single_merchant
                          ? `Visit ${brand_name ?? 'Store'}`
                          : 'Visit Brand',
                      },
                    });
                  }}
                >
                  {is_single_merchant
                    ? `Visit ${brand_name ?? 'Store'}`
                    : 'Visit Brand'}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      <BottomSheet
        open={open}
        onDismiss={() => setOpen(false)}
        header={false}
        initialFocusRef={false}
        maxHeight={viewportToPixels('75vh')}
        style={{
          overflow: 'hidden',
        }}
      >
        <OfferTerms data={tnc} />
      </BottomSheet>
    </>
  );
}

export default OffersDetailPage;
